module.exports = __webpack_public_path__ + "static/media/call-background.166d52b6.svg";